<template>
  <a-drawer width="80%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
<!--      <a-form-model-item label="类型" prop="type" >-->
<!--        <a-select v-model="form.type" placeholder="请选择类型" >-->
<!--          <a-select-option :key="0">周会员</a-select-option>-->
<!--          <a-select-option :key="1">月会员</a-select-option>-->
<!--          <a-select-option :key="2">年会员</a-select-option>-->
<!--        </a-select>-->
<!--      </a-form-model-item>-->
      <a-form-model-item label="总价" prop="totalPrice" >
        <a-input v-model="form.totalPrice" placeholder="请输入总价" />
      </a-form-model-item>
      <a-form-model-item label="每天单价" prop="unitPrice" >
        <a-input v-model="form.unitPrice" placeholder="请输入每天单价" />
      </a-form-model-item>
<!--      <a-form-model-item label="ios内购产品id" prop="productId" >-->
<!--        <a-input v-model="form.productId" placeholder="请输入ios内购产品id" />-->
<!--      </a-form-model-item>-->

      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>

      <a-form-model-item label="英文备注" prop="remarkEn" >
        <a-input v-model="form.remarkEn" placeholder="请输入英文备注" />
      </a-form-model-item>
      
      <a-form-model-item label="日语备注" prop="remarkJa" >
        <a-input v-model="form.remarkJa" placeholder="请输入日语备注" />
      </a-form-model-item>

      <a-form-model-item label="印尼备注" prop="remarkId" >
        <a-input v-model="form.remarkId" placeholder="请输入印尼备注" />
      </a-form-model-item>

      <a-form-model-item label="葡语备注" prop="remarkPt" >
        <a-input v-model="form.remarkPt" placeholder="请输入葡语备注" />
      </a-form-model-item>

      <a-form-model-item label="西语备注" prop="remarkEs" >
        <a-input v-model="form.remarkEs" placeholder="请输入西语备注" />
      </a-form-model-item>

      <a-form-model-item label="划线价" prop="crossedPrice" >
        <a-input v-model="form.crossedPrice" placeholder="请输入划线价" />
      </a-form-model-item>
      <a-form-model-item label="首购价格" prop="firstPurchasePrice" >
        <a-input v-model="form.firstPurchasePrice" placeholder="请输入首购价格" />
      </a-form-model-item>
      <a-form-model-item label="首购每天单价" prop="unitFirstPurchasePrice" >
        <a-input v-model="form.unitFirstPurchasePrice" placeholder="请输入首购每天单价" />
      </a-form-model-item>
      <a-form-model-item label="首购备注" prop="firstPurchaseRemark" >
        <a-input v-model="form.firstPurchaseRemark" placeholder="请输入首购备注" />
      </a-form-model-item>
      <a-form-model-item label="首购英文备注" prop="firstPurchaseRemarkEn" >
        <a-input v-model="form.firstPurchaseRemarkEn" placeholder="请输入首购英文备注" />
      </a-form-model-item>
      <a-form-model-item label="首购日语备注" prop="firstPurchaseRemarkJa" >
        <a-input v-model="form.firstPurchaseRemarkJa" placeholder="请输入首购日语备注" />
      </a-form-model-item>
      <a-form-model-item label="首购印尼备注" prop="firstPurchaseRemarkId" >
        <a-input v-model="form.firstPurchaseRemarkId" placeholder="请输入首购印尼备注" />
      </a-form-model-item>
      <a-form-model-item label="首购葡语备注" prop="firstPurchaseRemarkPt" >
        <a-input v-model="form.firstPurchaseRemarkPt" placeholder="请输入首购葡语备注" />
      </a-form-model-item>
      <a-form-model-item label="首购西语备注" prop="firstPurchaseRemarkEs" >
        <a-input v-model="form.firstPurchaseRemarkEs" placeholder="请输入首购西语备注" />
      </a-form-model-item>
<!--      <a-form-model-item label="总价" prop="totalPrice" >-->
<!--        <a-input v-model="form.totalPrice" placeholder="请输入总价" />-->
<!--      </a-form-model-item>-->
<!--      <a-form-model-item label="备注" prop="remark" >-->
<!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
<!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getMenu, addMenu, updateMenu } from '@/api/vip/menu'
import TagSelectOption from "@/components/TagSelect/TagSelectOption";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    TagSelectOption
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        type: null,

        unitPrice: null,

        productId: null,

        totalPrice: null,

        createTime: null,

        firstPurchasePrice: null,
        unitFirstPurchasePrice: null,

        remark: null,
        remarkEn: null,
        remarkJa: null,
        remarkId: null,
        remarkPt: null,
        remarkEs: null,
        firstPurchaseRemark: null,
        firstPurchaseRemarkEn: null,
        firstPurchaseRemarkJa: null,
        firstPurchaseRemarkId: null,
        firstPurchaseRemarkPt: null,
        firstPurchaseRemarkEs: null,

        crossedPrice: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        type: [
          { required: true, message: '类型 0-周会员  1-月会员  2-年会员不能为空', trigger: 'change' }
        ],
        // unitPrice: [
        //   { required: true, message: '每天单价不能为空' }
        // ],
        totalPrice: [
          { required: true, message: '总价不能为空' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        type: null,
        unitPrice: null,
        productId: null,
        totalPrice: null,
        createTime: null,
        remark: null,
        firstPurchasePrice: null,
        firstPurchaseRemark: null,
        firstPurchaseRemarkEn: null,
        unitFirstPurchasePrice: null,
        crossedPrice: null
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMenu({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
  this.$refs.form.validate(valid => {
    if (valid) {
      // 将 null 转换为 空字符串
      if (this.form.firstPurchasePrice === null) {
        this.form.firstPurchasePrice = '';
      }
      if (this.form.unitPrice === null) {
        this.form.unitPrice = '';
      }

      this.submitLoading = true;
      if (this.form.id !== undefined && this.form.id !== null) {
        updateMenu(this.form).then(response => {
          this.$message.success('修改成功', 3);
          this.open = false;
          this.$emit('ok');
        }).finally(() => {
          this.submitLoading = false;
        });
      } else {
        addMenu(this.form).then(response => {
          this.$message.success('新增成功', 3);
          this.open = false;
          this.$emit('ok');
        }).finally(() => {
          this.submitLoading = false;
        });
      }
    } else {
      return false;
    }
  });
}
  }
}
</script>
